import { clients } from '@/lib/https';
import { updateIamMe } from '@/api-client/use-update-profile';

export const updateIamAccount = async (data: {
  itemId: string;
  firstName?: string;
  lastName?: string;
  phoneNumber?: string;
  profileImageUrl?: string;
  memberships: { organizationId: string; roles: string[] }[];
}) => {
  return updateIamMe({
    firstName: data.firstName,
    lastName: data.lastName,
    phoneNumber: data.phoneNumber,
    profileImageUrl: data.profileImageUrl,
  });
};

export const inviteOrgMember = async (orgId: string, data: { email: string; role: string }) => {
  const projectKey = import.meta.env.VITE_X_BLOCKS_KEY || '';
  return clients.post<{ isSuccess: boolean; errors?: string[] }>(
    '/idp/v1/Iam/Create',
    JSON.stringify({
      email: data.email,
      roles: [data.role],
      projectKey,
      memberships: [
        {
          organizationId: orgId,
          roles: [data.role],
          permissions: [],
        },
      ],
    })
  );
};
